import _ from 'lodash';

import api from './api';
import constants from './constant';

const {
  BASE_ICSI_REPORT_URL, BASE_IUI_REPORT_URL, BASE_STC_REPORT_URL, REPORT_TYPE,
} = constants.CHART_REPORT;

function getBaseURL(type) {
  let baseURL;
  if (type === REPORT_TYPE.ICSI) {
    baseURL = BASE_ICSI_REPORT_URL;
  } else if (type === REPORT_TYPE.STC) {
    baseURL = BASE_STC_REPORT_URL;
  } else if (type === REPORT_TYPE.IUI) {
    baseURL = BASE_IUI_REPORT_URL;
  }
  return baseURL;
}

function updateURLParamsWithTimeStamp(params) {
  const result = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((k) => {
      result.set(k, params[k]);
    });
  }
  result.set('t', `${new Date().getTime()}`);
  return result.toString();
}


function getReport(id, params, type) {
  const baseURL = getBaseURL(type);
  const url = `${baseURL}/chart/${id}?${updateURLParamsWithTimeStamp(params)}`;
  return new Promise((resolve, reject) => {
    api.get(url).then(
      (response) => {
        if (response.ok) {
          const data = response.body;
          resolve({ data, message: '', success: true });
        } else {
          reject(
            new Error(`Get Error: ${response}, url: ${url}`),
            { data: null, success: false },
          );
        }
      },
    );
  });
}

function createReport(payload, type) {
  const baseURL = getBaseURL(type);
  const url = `${baseURL}/`;
  return new Promise((resolve, reject) => {
    api.post(url, payload).then(
      (response) => {
        if (response.ok) {
          const data = response.body;
          resolve({
            data, message: '', success: true, error: null,
          });
        } else {
          // TODO: Chan : Make this cooler
          // get at least one from array of errors
          const errors = _.map(response.body.error.errors, val => val.message || '');
          reject(new Error(JSON.stringify(errors)));
        }
      },
      (response) => {
        reject(
          new Error(`Request Error: ${response}, url: ${url}`),
          { data: null, success: false },
        );
      },
    );
  });
}

function updateReport(id, payload, type) {
  const baseURL = getBaseURL(type);
  const url = `/${baseURL}/${id}`;
  return new Promise((resolve, reject) => {
    api.put(url, payload).then(
      (response) => {
        if (response.ok) {
          const data = response.body;
          resolve({
            data, message: '', success: true, error: null,
          });
        } else {
          // TODO: Chan : Make this cooler
          // get at least one from array of errors
          const errors = _.map(response.body.error.errors, val => val.message || '');
          reject(new Error(JSON.stringify(errors)));
        }
      },
      (response) => {
        reject(
          new Error(`Request Error: ${response}, url: ${url}`),
          { data: null, success: false },
        );
      },
    );
  });
}


function patchReport(id, payload, type) {
  const baseURL = getBaseURL(type);
  const url = `/${baseURL}/patch/${id}`;
  return new Promise((resolve, reject) => {
    api.patch(url, payload).then(
      (response) => {
        if (response.ok) {
          const data = response.body;
          resolve({
            data, message: '', success: true, error: null,
          });
        } else {
          // TODO: Chan : Make this cooler
          // get at least one from array of errors
          const errors = _.map(response.body.error.errors, val => val.message || '');
          reject(new Error(JSON.stringify(errors)));
        }
      },
      (response) => {
        reject(
          new Error(`Request Error: ${response}, url: ${url}`),
          { data: null, success: false },
        );
      },
    );
  });
}

function updateReportImageComment(payload, type) {
  /*
  {
    id,
    imageID,
    comment
  }
  */
  const baseURL = getBaseURL(type);
  const url = `/${baseURL}/updateImageComment`;
  return new Promise((resolve, reject) => {
    api.patch(url, payload).then(
      (response) => {
        if (response.ok) {
          const data = response.body;
          resolve({
            data, message: '', success: true, error: null,
          });
        } else {
          // TODO: Chan : Make this cooler
          // get at least one from array of errors
          const errors = _.map(response.body.error.errors, val => val.message || '');
          reject(new Error(JSON.stringify(errors)));
        }
      },
      (response) => {
        reject(
          new Error(`Request Error: ${response}, url: ${url}`),
          { data: null, success: false },
        );
      },
    );
  });
}


function deleteReportImage(payload, type) {
  /*
  {
    id,
    imageID,
  }
  */
  const baseURL = getBaseURL(type);
  const url = `/${baseURL}/deleteImage`;
  return new Promise((resolve, reject) => {
    api.delete(url, payload).then(
      (response) => {
        if (response.ok) {
          const data = response.body;
          resolve({
            data, message: '', success: true, error: null,
          });
        } else {
          // TODO: Chan : Make this cooler
          // get at least one from array of errors
          const errors = _.map(response.body.error.errors, val => val.message || '');
          reject(new Error(JSON.stringify(errors)));
        }
      },
      (response) => {
        reject(
          new Error(`Request Error: ${response}, url: ${url}`),
          { data: null, success: false },
        );
      },
    );
  });
}

function uploadReportImage(pk, payload, type, onProgress = function fn() {}) {
  // pk is the report pk, not chart pk
  const baseURL = getBaseURL(type);
  const url = `/${baseURL}/uploadReportImage/${pk}`;
  return new Promise((resolve, reject) => {
    api.upload(url, payload, onProgress).then(
      (response) => {
        if (response.ok) {
          const data = response.body;
          resolve({
            data, message: '', success: true, error: null,
          });
        } else {
          // TODO: Chan : Make this cooler
          // get at least one from array of errors
          const { status, body } = response;
          if (status === 404 || status === 422) {
            if (typeof body.message === 'string') {
              const errors = [body.message || ''];
              reject(new Error(JSON.stringify(errors)));
            }
          }
          const errors = _.map(response.body.error.errors, val => val.message || '');
          reject(new Error(JSON.stringify(errors)));
        }
      },
      (response) => {
        reject(
          new Error(`Request Error: ${response}, url: ${url}`),
          { data: null, success: false },
        );
      },
    );
  });
}

export default {
  getReport,
  createReport,
  updateReport,
  patchReport,
  uploadReportImage,
  updateReportImageComment,
  deleteReportImage,
};
